import { useState } from "react";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { insertProfileVideoWeightRoomAction } from "../../../../store/ProfileVideoActions";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

export default function AddProfileVideoWeightRoom({ isOpen, setIsOpen }) {
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const r_profileVideos = useSelector((state) => state.profileVideo);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const file = document.getElementById("file").files[0];

    if (!file) {
      toast.warn("No file selected. Please choose a video to upload.");
      return;
    }

    if (!file.type.startsWith("video/")) {
      toast.error("Invalid file type. Please upload a valid video file.", {
        autoClose: 5000,
      });
      return;
    }
    const maxSizeInBytes = 600 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      toast.warning("Video size should not exceed 600MB.", {
        position: "top-right",
      });
      return;
    }

    try {
      await dispatch(
        insertProfileVideoWeightRoomAction(
          apiInstance,
          file,
          6,
          data.title,
          data.weight,
          data.reps,
          setIsOpen,
        ),
      );
      toast.success("Video uploaded successfully!", {
        autoClose: 3000,
      });
    } catch (error) {
      toast.error(
        "An error occurred while uploading the video. Please try again.",
        {
          autoClose: 5000,
        },
      );
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setData({});
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
          <div className="p-8">
            <DialogTitle className="text-xl uppercase pb-4">
              New Weight Room Video
            </DialogTitle>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="accoladeDescription"
                  >
                    Title
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    name="title"
                    onChange={handleChange}
                    placeholder="Title..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                  <div className="text-gray-500 text-sm text-right">
                    {data?.title ? data.title.length : 0} / 100 characters
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="accoladeDescription"
                  >
                    Weight
                  </label>
                  <input
                    type="number"
                    name="weight"
                    step={0.01}
                    min={0}
                    onChange={handleChange}
                    placeholder="Weight..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="accoladeDescription"
                  >
                    Reps
                  </label>
                  <input
                    type="number"
                    name="reps"
                    step={1}
                    min={0}
                    onChange={handleChange}
                    placeholder="Reps..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="accoladeDescription"
                  >
                    Video
                  </label>
                  <input
                    id="file"
                    type="file"
                    name="file"
                    accept="video/*"
                    placeholder="Upload your video..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
              </div>
              <div className="flex  bg-gray-50 sm:flex sm:flex-row-reverse p-4 justify-center space-x-5">
                {r_profileVideos.btnLoading ? (
                  <button
                    type="button"
                    disabled
                    className="bg-red-500/75 text-white p-3 px-10 rounded-md uppercase text-sm ml-3 cursor-not-allowed"
                  >
                    <FontAwesomeIcon icon={faSpinner} spin /> Loading...
                  </button>
                ) : (
                  <>
                    <button
                      type="submit"
                      className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                    >
                      Add
                    </button>
                    <button
                      type="reset"
                      onClick={handleClose}
                      className="text-gray-600 font-semibold hover:text-gray-800"
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
